import ForecasterDateRange from '@/Enums/Forecaster/DateRange.enum';
import ForecasterDateTab from '@/Enums/Forecaster/DateTab.enum';
import DateFormat from '@/Enums/Format/DateFormat.enum';
import type GeoType from '@/Enums/Geography/GeographyType.enum';
import type { ITargetingLocation } from '@/Interfaces/Location.interface';
import moment from 'moment';
import { dateToRangeFormat } from '.';

const API_DATE_FORMAT = 'YYYY-MM-DD';

export const getLocationsByType = (geographic: ITargetingLocation[] = [], mapScale: GeoType) =>
  geographic.filter(geo => geo.type === mapScale);

const rangeTabs = [ForecasterDateTab.Week, ForecasterDateTab.Day, ForecasterDateTab.Month];

const getTabDateRange = () => ({
  [ForecasterDateTab.Week]: () => [moment(), moment().add({ days: 6 })],
  [ForecasterDateTab.Day]: () => [moment()],
  [ForecasterDateTab.Month]: () => [moment(), moment().add({ days: 29 })],
});

const daysInRange = {
  [ForecasterDateTab.Week]: ForecasterDateRange.Week,
  [ForecasterDateTab.Day]: ForecasterDateRange.Day,
  [ForecasterDateTab.Month]: ForecasterDateRange.Month,
};

export const getDateUpdateValues = (tabIndex: Exclude<ForecasterDateTab, ForecasterDateTab.Custom>) => {
  if (!rangeTabs.includes(+tabIndex)) return null;
  return {
    dateRange: dateToRangeFormat(...getTabDateRange()[tabIndex]()),
    daysInRange: daysInRange[tabIndex],
  };
};

/** Explicit ISO flight dates for the Custom tab; null for presets or an incomplete range. */
export const getCustomFlightDates = (
  tabIndex: number,
  dateRange?: string | null,
): { startDate: string; endDate: string } | null => {
  if (+tabIndex !== ForecasterDateTab.Custom || !dateRange) return null;
  const [start, end] = dateRange.split(' - ');
  if (!start || !end) return null;
  return {
    startDate: moment(start, DateFormat.DayShortMonthYear).format(API_DATE_FORMAT),
    endDate: moment(end, DateFormat.DayShortMonthYear).format(API_DATE_FORMAT),
  };
};
